import React from 'react';
interface Props {
  fillColor?: string;
}
function InsulinPumpsIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none">
      <g clipPath="url(#clip0_851_3635)">
        <path
          d="M6.72188 1.17712C6.83438 1.57399 6.60625 1.98962 6.20625 2.10524C3.4875 2.88337 1.5 5.38962 1.5 8.35524C1.5 11.9459 4.40938 14.8552 8 14.8552C11.5906 14.8552 14.5 11.9459 14.5 8.35524C14.5 5.38962 12.5125 2.88337 9.79375 2.10524C9.39687 1.99274 9.16562 1.57712 9.27812 1.17712C9.39062 0.777115 9.80625 0.54899 10.2063 0.66149C13.55 1.62087 16 4.70212 16 8.35524C16 12.774 12.4187 16.3552 8 16.3552C3.58125 16.3552 0 12.774 0 8.35524C0 4.70212 2.45 1.62087 5.79375 0.664615C6.19062 0.552115 6.60625 0.78024 6.72188 1.18024V1.17712Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3635">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.355469)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default InsulinPumpsIcon;
